/* eslint-disable */
import * as types from '../mutation-types';
import apiService from 'src/utils/apiService';

// initial state
const state = {
  showLoginModal: false,
  loginModalActiveTab: '',
  revision: null,
};

// getters
const getters = {
};

// actions
const actions = {
  getCurrentRevision({ commit }) {
    apiService.getRevision().then((data) => {
      commit(types.SET_REVISION, data);
    });
  },
  toggleLoginModal({ commit }, { val, activeTab }) {
    commit(types.TOGGLE_LOGIN_MODAL, { val, activeTab });
  },
};

// mutations
const mutations = {
  [types.TOGGLE_LOGIN_MODAL](s, { val, activeTab }) {
    s.showLoginModal = val;
    s.loginModalActiveTab = activeTab;
  },
  [types.SET_REVISION](s, revision) {
    s.revision = revision;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js